
import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'

//import echarts from 'echarts';

// 引入三方组件库
import ElementUI from 'element-ui';
 import 'element-ui/lib/theme-chalk/index.css';//el ui官方主题
// import './assets/theme/green/index.css';//elementui 绿色主题
import './assets/theme/blue/index.css'; //自定义配色的主题

import Cookies from 'js-cookie'

//import './assets/theme/echarts/shine'//echart主题

import './commonJs/directives.js';

//全局变量
import  '@/commonJs/global.js'

import MyDialog from './components/MyDialog';
//全局引入常用自定义组件
import XhFilterLayout from './components/XhComponents/XhFilterLayout';
import XhPageTable from './components/XhComponents/XhPageTable';
import XhDialog from './components/XhComponents/XhDialog';



// 引用工具js
import api from './commonJs/http.js'
import util from './commonJs/util.js'
import base64 from './commonJs/base64.js'
import menuRedirect from './router/menuRedirect.js'


// 导入全局样式表
import "./assets/global/body.less";
import "./assets/global/map.css";
import "./assets/global/transition.css";
import "./assets/icon/iconfont.css";
import "./assets/global/table.css";
import "./assets/global/custom.less";
import "./assets/icon/font.css";


Vue.component('MyDialog', MyDialog);
//element-ui组件
Vue.use(ElementUI);

//常用自定义组件
Vue.component('XhFilterLayout', XhFilterLayout);
Vue.component('XhPageTable', XhPageTable);
Vue.component('XhDialog', XhDialog);

// 将axios方法绑定到全局
Vue.prototype.$api = api;
//cookies
Vue.prototype.$Cookies = Cookies;
//将工具类方法绑定到全局
Vue.prototype.$util = util;
Vue.prototype.$base64 = base64;
Vue.prototype.$redirect=menuRedirect;
Vue.prototype.$echarts = null;// echarts
Vue.config.productionTip = false
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
